import ConditionalWrapper from '@atoms/ConditionalWrapper/ConditionalWrapper';
import { IFigCaption } from '@models/IFigCaption';
import PositioningEnum from '@models/enums/PositioningEnum';
import classNames from 'classnames';
import { PropsWithChildren } from 'react';

const FigCaption = ({
  caption,
  children,
  textAlignment,
  captionStyles,
}: PropsWithChildren<IFigCaption>) => {
  const alignment = (): string => {
    switch (textAlignment) {
      case PositioningEnum.Right:
        return 'text-right';
      case PositioningEnum.Center:
        return 'text-center';
      default:
        return 'text-left';
    }
  };

  return (
    <ConditionalWrapper
      condition={!!caption}
      wrapper={(children) => (
        <figure>
          {children}
          {caption && (
            <figcaption
              className={classNames(
                alignment(),
                captionStyles ??
                  'tw-text-body tw-mt-xs tw-text-grey-100 [&_a]:tw-underline'
              )}
              dangerouslySetInnerHTML={{ __html: caption }}
            />
          )}
        </figure>
      )}
    >
      {children}
    </ConditionalWrapper>
  );
};

export default FigCaption;
